var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessfulpurchaseRafiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-125"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.55,
    y: 80.06,
    width: 134.71,
    height: 224.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.7,75.46H59.83a1.34,1.34,0,0,0-1.34,1.34h0a1.34,1.34,0,0,0,1.34,1.33H217.7A1.34,1.34,0,0,0,219,76.8h0A1.34,1.34,0,0,0,217.7,75.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.22,
    y: 80.06,
    width: 137.76,
    height: 224.06,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.26 304.12 68.55 304.12 68.55 307.91 207.2 307.91 203.26 304.12",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.5 304.12 80.74 304.12 84.68 307.91 222.44 307.91 218.5 304.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.07,
    y: 131.21,
    width: 208.06,
    height: 121.75,
    transform: "translate(332.19 51.99) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.86 296.12 153.83 88.06 176 88.06 129.03 296.12 106.86 296.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.8 296.12 180.76 88.06 189.41 88.06 142.44 296.12 133.8 296.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.44,
    y: 191.58,
    width: 208.06,
    height: 1.02,
    transform: "translate(392.56 -8.38) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.54,
    y: 73.07,
    width: 13.77,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.95,
    y: 73.07,
    width: 10.73,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.31,
    y: 73.07,
    width: 13.77,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.72,
    y: 73.07,
    width: 10.73,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.09,
    y: 73.07,
    width: 13.77,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.91,
    y: 73.07,
    width: 7.94,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.76,
    y: 73.07,
    width: 6.18,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.85,
    y: 73.07,
    width: 7.94,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.69,
    y: 73.07,
    width: 6.18,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.78,
    y: 73.07,
    width: 7.94,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 284.85,
    y: 80.06,
    width: 134.71,
    height: 224.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,75.46H276.13a1.34,1.34,0,0,0-1.34,1.34h0a1.34,1.34,0,0,0,1.34,1.33H434a1.34,1.34,0,0,0,1.34-1.33h0A1.34,1.34,0,0,0,434,75.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.52,
    y: 80.06,
    width: 137.76,
    height: 224.06,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.56 304.12 284.85 304.12 284.85 307.91 423.5 307.91 419.56 304.12",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.8 304.12 297.04 304.12 300.98 307.91 438.74 307.91 434.8 304.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.37,
    y: 131.21,
    width: 208.06,
    height: 121.75,
    transform: "translate(548.49 -164.31) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.16 296.12 370.13 88.06 392.3 88.06 345.33 296.12 323.16 296.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.09 296.12 397.06 88.06 405.71 88.06 358.74 296.12 350.09 296.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.74,
    y: 191.58,
    width: 208.06,
    height: 1.02,
    transform: "translate(608.85 -224.67) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.84,
    y: 73.07,
    width: 13.77,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.25,
    y: 73.07,
    width: 10.73,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.61,
    y: 73.07,
    width: 13.77,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.02,
    y: 73.07,
    width: 10.73,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.39,
    y: 73.07,
    width: 13.77,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.21,
    y: 73.07,
    width: 7.94,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.05,
    y: 73.07,
    width: 6.18,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.15,
    y: 73.07,
    width: 7.94,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.99,
    y: 73.07,
    width: 6.18,
    height: 203.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.08,
    y: 73.07,
    width: 7.94,
    height: 203.39,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 422.33,
    y: 328.23,
    width: 9.19,
    height: 54.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.56,
    y: 328.23,
    width: 5.41,
    height: 54.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.08,
    y: 328.23,
    width: 9.19,
    height: 54.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.58,
    y: 328.23,
    width: 5.41,
    height: 54.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.19,
    y: 328.23,
    width: 130.46,
    height: 9.57,
    transform: "translate(740.83 666.03) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.97,
    y: 328.23,
    width: 9.19,
    height: 54.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.47,
    y: 328.23,
    width: 5.41,
    height: 54.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.33,
    y: 328.23,
    width: 32.93,
    height: 9.57,
    transform: "translate(569.59 666.03) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.22,
    y: 328.23,
    width: 9.19,
    height: 54.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.45,
    y: 328.23,
    width: 5.41,
    height: 54.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.43,
    y: 333.21,
    width: 31.67,
    height: 49.19,
    transform: "translate(222.52 715.61) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.09,
    y: 333.21,
    width: 69.75,
    height: 49.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.43,
    y: 338.07,
    width: 101.74,
    height: 2.6,
    transform: "translate(292.6 678.74) rotate(180)",
    style: {
      fill: "#e6e6e6",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.68,
    y: 331.64,
    width: 33.42,
    height: 7.53,
    transform: "translate(220.77 670.8) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.09,
    y: 331.64,
    width: 71.49,
    height: 7.53,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.37,
    cy: 363.26,
    r: 19.14,
    transform: "translate(-173.57 516.86) rotate(-79.24)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,359.47a14.64,14.64,0,1,0-3.79,20.36A14.64,14.64,0,0,0,216.61,359.47Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-125"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-125",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.73,118.33c-3.5-1.07-7.84,5.23-10.51,12.29s-7.08,8.27-11.8,11.1c8.72,12.2,29.05,9.65,35.81,8.11s12.81,3.84,21.44-2.49c7.73-5.67,7.16-22.56-6.49-30.26C263.2,106.71,232.06,105.67,231.73,118.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.74,224.17h-9.6a5.26,5.26,0,0,1-5.3-6.21l1.08-7.33a7.46,7.46,0,0,1,7.12-6.21h9.59a5.25,5.25,0,0,1,5.3,6.21L275.86,218A7.48,7.48,0,0,1,268.74,224.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.74,224.42h-9.6a5.54,5.54,0,0,1-4.28-1.89,5.63,5.63,0,0,1-1.26-4.61l1.07-7.33a7.71,7.71,0,0,1,7.37-6.42h9.59a5.57,5.57,0,0,1,4.29,1.88,5.68,5.68,0,0,1,1.26,4.61L276.1,218A7.7,7.7,0,0,1,268.74,224.42ZM262,204.67a7.19,7.19,0,0,0-6.87,6L254.09,218a5.18,5.18,0,0,0,1.15,4.21,5,5,0,0,0,3.9,1.72h9.6a7.19,7.19,0,0,0,6.87-6l1.07-7.33a5.15,5.15,0,0,0-1.14-4.21,5,5,0,0,0-3.91-1.71Z",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.39,213.92h-.05a.25.25,0,0,1-.19-.3c.83-3.88.71-5.66-2.2-6.59a.25.25,0,1,1,.16-.48c3.53,1.14,3.28,3.69,2.53,7.18A.26.26,0,0,1,275.39,213.92Z",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.46 112.35 310.27 94.95 348.25 124.31 331.44 141.72 293.46 112.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.24 93.95 310.27 94.95 348.25 124.31 350.55 116.14 311.24 93.95",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.78,106.9c-2.46-1.67-4.06-3.72-4.4-5.63a3.4,3.4,0,0,1,.54-2.66c2.75-3.82,6.24-1.45,9.93,1.06l.49.33-.27.39-.49-.33c-3.64-2.48-6.79-4.63-9.28-1.18a3,3,0,0,0-.46,2.3c.32,1.79,1.85,3.74,4.21,5.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.69,159.57,279,148.82l7.18-5.38,1.75-1.32.87-.65.42-.32.21-.18a13.11,13.11,0,0,0,2.12-2.66,32.88,32.88,0,0,0,3.18-7.36,81.24,81.24,0,0,0,2-8.34c.55-2.86,1-5.76,1.3-8.69s.62-5.9.81-8.79v-.08a2.27,2.27,0,0,1,4.53,0,106,106,0,0,1-.08,18.51,69.27,69.27,0,0,1-1.47,9.35,38,38,0,0,1-3.39,9.4,20,20,0,0,1-3.27,4.55l-.6.58-.46.4-.88.76-1.77,1.52q-3.45,2.94-7,5.8l-7.12,5.64c-2.42,1.83-4.81,3.66-7.32,5.43h0a4.58,4.58,0,0,1-5.38-7.4Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.92,107.47l-7.81-3.67,8.07-4.21s6.24,3.19,4.24,7.74Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.47 98.43 296.42 95.27 299.18 99.59 291.11 103.8 289.47 98.43",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.82,163.66c.14,6.49-.77,20-5.33,48H232.14c.61-14.79,1.33-24.06-5.74-54.42a99,99,0,0,1,14.73-1.89,115,115,0,0,1,16.51,0c3.55.32,7.35.9,10.25,1.39A7.15,7.15,0,0,1,273.82,163.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,207h0a.26.26,0,0,1-.22-.29C276.09,184,243,159.31,236,156a.25.25,0,1,1,.21-.45c4.16,2,14.28,9.2,22.79,18.52,7.51,8.21,16.08,20.55,14.31,32.74A.26.26,0,0,1,273,207Z",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.77,136.79c1,5.31,2.08,15-1.64,18.59a44.48,44.48,0,0,0,14.78,10.31c7.1-4.45,1.73-10.31,1.73-10.31-5.92-1.42-5.77-5.81-4.74-9.94Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.9,140.32l6,5.12a17,17,0,0,0-.51,2.93c-2.26-.33-5.37-2.81-5.61-5.18A8,8,0,0,1,246.9,140.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.46,130c3.49,8.16,4.8,11.7,10.54,14.48,8.65,4.18,17.92-1.89,16.93-10.94-.88-8.14-6.44-20.13-15.8-20.54A12.12,12.12,0,0,0,236.46,130Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.71,117.46c2,4.89-5.83,14.46-11.45,18.22C228.1,120.78,232.36,114.59,246.71,117.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,112.54c9.67,2.46-13.75,10.59-20.5,11C239.64,112.08,244.06,109.58,253.14,112.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,211.69s-3.13,65.47-2.83,92.77c.31,28.4-18.32,99.67-18.32,99.67l-7.17-2s3.45-58,6.84-97.59c-5.12-30.4-7.95-92.89-7.95-92.89Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.76,402.49l-6.68-1.55a.73.73,0,0,0-.85.44l-2.73,6.67a1.46,1.46,0,0,0,1.05,1.9c3.46.74,3.7.58,8,1.59,2.68.62,7.3,2.86,11.09,2.86s3.08-3.58,1.49-3.86c-5.75-1.05-6-3.09-10.08-7.17A2.94,2.94,0,0,0,246.76,402.49Z",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,211.69s-20.07,94.07-24.86,103.12c-6.46,12.22-66.79-5.11-68.85-5.07l-.3-6.19s29.71-.68,54.33.55c0-30.83,12.83-92.41,12.83-92.41Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.12,309.66l4.48-5.2a.72.72,0,0,0,0-.95L166,298a1.45,1.45,0,0,0-2.17.05c-2.26,2.71-2.23,3-5.15,6.38-1.79,2.08-3.1,3.82-5.77,6.5s-.13,5.52,1.19,4.6c4.8-3.35,5.11-3.33,10.64-5.08A3,3,0,0,0,166.12,309.66Z",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,127.81c.24.68.8,1.1,1.24.95s.61-.84.37-1.52-.8-1.11-1.25-.95S249.72,127.13,250,127.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.64,125.07c.25.68.8,1.1,1.25.94s.61-.83.36-1.51-.8-1.11-1.24-1S257.4,124.39,257.64,125.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83,123.66l1.46-1S258.91,124.18,257.83,123.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,127a19.36,19.36,0,0,0,4,3.48,3.1,3.1,0,0,1-2.26,1.32Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,135.6a8.5,8.5,0,0,0,1.17-.31.21.21,0,1,0-.14-.4,5.67,5.67,0,0,1-5.14-.54.21.21,0,1,0-.26.34A5.94,5.94,0,0,0,255.13,135.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09,135.05a6.46,6.46,0,0,0,4,2.86c2.22.49,3.2-1.53,2.48-3.56-.66-1.83-2.6-4.28-4.78-3.86A2.91,2.91,0,0,0,236.09,135.05Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.29,138.53a2,2,0,1,1-2-2A2,2,0,0,1,242.29,138.53Z",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.51,124.94a.45.45,0,0,0,.27-.2,3.41,3.41,0,0,1,2.48-1.8.42.42,0,0,0,.39-.45.42.42,0,0,0-.45-.39,4.2,4.2,0,0,0-3.17,2.23.42.42,0,0,0,.17.57A.38.38,0,0,0,247.51,124.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,120.17a.41.41,0,0,0,.19-.24.42.42,0,0,0-.28-.53,4.22,4.22,0,0,0-3.82.63.43.43,0,1,0,.55.65,3.34,3.34,0,0,1,3-.47A.44.44,0,0,0,260,120.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14,126.4l1.47-1.05S251.22,126.92,250.14,126.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,211.69l-1.11,83.16L218.83,285c-2-39.43,3.27-62.37,13.31-73.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.37,213.67l-36.9-1.19a.53.53,0,0,1-.49-.67l.56-2a.52.52,0,0,1,.52-.38l36.4,1.19a.53.53,0,0,1,.51.54l-.06,2A.53.53,0,0,1,268.37,213.67Z",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.71 270.79 247.12 251.34 248.43 233.91 257.71 270.79",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.16,165.67c-3.15-5.09-6-10.18-8.68-15.49a125.23,125.23,0,0,1-7.13-16.51c-.49-1.46-.93-3-1.31-4.52-.2-.77-.36-1.58-.51-2.39l-.33-2.25c-.38-3-.7-5.84-1-8.75-.52-5.82-.92-11.63-1.09-17.47a2.28,2.28,0,0,1,4.49-.62h0c1.39,5.66,2.6,11.34,3.79,17l1.75,8.44.45,2c.16.6.31,1.21.5,1.84.37,1.25.81,2.51,1.31,3.79,1,2.54,2.11,5.1,3.32,7.63s2.48,5.07,3.81,7.58c2.68,5,5.51,10,8.38,14.86l0,.06a4.57,4.57,0,0,1-7.82,4.75Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.69,100.28l8.6-4.41-8.39-3.52s-4.5,3.57-3.84,7.24Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.45 89.04 216.27 86.48 210.83 93.34 220.29 95.87 223.45 89.04",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.35,
    y: 100.5,
    width: 4,
    height: 1,
    transform: "translate(-26.74 108.46) rotate(-31.9)",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.56,
    y: 95.25,
    width: 8.46,
    height: 1,
    transform: "translate(-22.69 112.12) rotate(-31.9)",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.5 88.27 220.54 104.43 180.01 136.27 163.92 112.27 202.5 88.27",
    style: {
      fill: "#24A6DC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.57 105.36 220.54 104.43 180.01 136.27 189.28 140.32 221.57 105.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.35,93.76a.23.23,0,0,1-.18-.09.24.24,0,0,1,0-.34c2-1.73,3.51-3.1,5.25-3.6a.24.24,0,0,1,.3.16.24.24,0,0,1-.16.3c-1.64.47-3.16,1.81-5.07,3.5A.21.21,0,0,1,208.35,93.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.1,99.8a.25.25,0,0,1-.18-.08.24.24,0,0,1,0-.34c2.54-2.25,4.13-4.23,4.59-5.72a.25.25,0,0,1,.31-.16.25.25,0,0,1,.16.3c-.5,1.6-2.09,3.6-4.74,5.94A.25.25,0,0,1,215.1,99.8Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulpurchaseRafiki);
export default __webpack_public_path__ + "static/media/Successful purchase-rafiki.ff8feda2b49b76797f7945f2b5ae1681.svg";
export { ForwardRef as ReactComponent };